const GENERAL_REGEX = {
	removeComma: {
		pattern: /,/g,
	},
	removeNonDigit: {
		pattern: /\D/g,
	},
	septateThreeCharacter: {
		pattern: /\B(?=(\d{3})+(?!\d))/g,
	},
};

export default GENERAL_REGEX;
